import { BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ReaderModeToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  size?: 'sm' | 'default';
  className?: string;
}

/**
 * Toggles the paginated "e-reader" display mode for an article/section
 * body (see `PaginatedReader`) — styled to match the other action
 * buttons (Star/Zap/Comments/Highlight), as a plain visibility switch
 * rather than something that publishes anything.
 */
export function ReaderModeToggle({ enabled, onToggle, size = 'sm', className }: ReaderModeToggleProps) {
  return (
    <Button
      type="button"
      variant={enabled ? 'default' : 'outline'}
      size={size}
      onClick={() => onToggle(!enabled)}
      title={enabled ? 'Exit e-reader mode' : 'Open in paginated e-reader mode'}
      className={cn('gap-1.5', className)}
    >
      <BookOpen className="size-4" />
      <span className="hidden sm:inline">Reader</span>
    </Button>
  );
}
